/**
 * Import all front-end JS scripts.
 * 
 * Compiles to assets/scripts/theme-scripts.js
 */

 /* eslint-disable no-unused-vars */

 // Import ES6 modules (recommended)
 // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import
import mainNavigation from './base/main-navigation';


// Or import entire JS files the "old school" way
// import './test.js'

import "./base/main-navigation-mobile.js";
import "./base/usa-banner.js";
import "./base/single-meeting.js";
import "./base/mat-accordion-block.js";
import "./base/mobile-menu-setup.js";
// import "./base/header-setup.js";
